//
//
//
//
//
//
//
//
//

export default {
    props: {
        disable: Boolean,
    },

    data() {
        return {
            isDraggedOver: false,
        };
    },

    methods: {
        onDragEnter() {
            this.isDraggedOver = true;
        },
        onDragLeave() {
            this.isDraggedOver = false;
        },
        onDragOver(ev) {
            ev.preventDefault();
        },
        onDrop(ev) {
            ev.preventDefault();

            this.isDraggedOver = false;

            this.$emit('drop', ev.dataTransfer);
        },
    },
};
